var render = function render(){var _vm=this,_c=_vm._self._c;return _c('register-company',{on:{"continue":$event => _vm.callback($event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }